import { AxiosResponse } from "axios";

import { axiosInstance, MessageResponse } from "./common";

export interface ActionAgainstPerpetrator {
    stakeholder_id: string;
    recommended_actions?: string[] | null;
    recommended_action_approver?: string | null;
    recommended_action_implementation_date?: string | null;
    implementation_owner?: string | null;
    closure_note?: string | null;
}

export interface ActionAgainstPerpetratorUI extends ActionAgainstPerpetrator {
    id: string; //for row order, so it must survive reorders
    is_added: boolean;
    is_dirty: boolean;
}

export interface ActionsAgainstPerpetratorsResponse {
    actions_against_perpetrators: ActionAgainstPerpetrator[];
}

export interface UpsertActionsAgainstPerpetratorsRequest {
    actions_against_perpetrators: ActionAgainstPerpetrator[];
}

const ActionsAgainstPerpetratorsAPI = {
    get: async (
        caseId: string
    ): Promise<ActionsAgainstPerpetratorsResponse> => {
        const response: AxiosResponse<ActionsAgainstPerpetratorsResponse> =
            await axiosInstance.get(
                `v1/cases/${caseId}/actions-against-perpetrators`
            );
        return response.data;
    },

    upsert: async (
        caseId: string,
        request: UpsertActionsAgainstPerpetratorsRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(
                `v1/cases/${caseId}/actions-against-perpetrators`,
                request
            );
        return response.data;
    },
};

export default ActionsAgainstPerpetratorsAPI;
